import { Cuenta } from "./cuenta";
import { UsuarioComunidadDto } from "./usuario";

export class Comunidad {
    constructor(
        public readonly Id: number,
        public readonly Nombre: string | null,
        public readonly TipoComunidad: number,
        public readonly CantidadPisos: number | null,
        public readonly FechaConstruccion: Date | null,
        public readonly Observaciones: string | null,
        public readonly Activo: boolean,
        public readonly ConsorcioId: number | null,
        public readonly Direccion: string | null,
        public readonly CodigoPostal: string | null,
        public readonly CategoriaSuterhId: number | null,
        public readonly ClaveSuterh: string | null,
        public Usuarios: UsuarioComunidadDto[],
        public Seguros: ComunidadSeguros[],
        public Adjuntos: ComunidadAdjunto[],
        public NumerosEmergencia: ComunidadNumeroEmergencia[],
        public TiposGastos: ComunidadTiposGastos[],
        public TipoGastosConceptosRecargo: ComunidadTipoGastoConceptoRecargoDto[],
        public Cuentas: Cuenta[],
        public PuntoEquilibrio: number | null
    ){}
}

export class SearchComunidadRequest {
    constructor(
      public readonly PageSize: number | null,
      public readonly PageNumber: number | null,
      public readonly OrderAscending: boolean | null,
      public readonly OrderFieldName: string | null,
      public readonly Nombre: string | null,
      public readonly ConsorcioId: number | null,
      public readonly PersonaId: number | null,
      public readonly Tipo: number | null,
      public readonly TenantId: number | null,
      public readonly VerSoloActivos: boolean | null
    ) {}
}

export class SaveComunidadDto {
    constructor(
        public Id: number,
        public Nombre: string | null,
        public TipoComunidad: number,
        public readonly FotoPerfilBase64: string | null,
        public readonly FotoPerfilExtension: string | null,
        public LatitudMapa: number | null,
        public LongitudMapa: number | null,
        public ContratistaPrincipal: string | null,
        public EjecutivaObra: string | null,
        public DirectorObra: string | null,
        public M2Obra: number | null,
        public TipoContratoId: number | null,
        public EstudioProyectista: string | null,
        public EstudioCalculista: string | null,
        public RepresentanteTecnico: string | null,
        public CantidadPisos: number | null,
        public FechaConstruccion: Date | null,
        public ConsorcioId: number | null,
        public Direccion: string | null,
        public CodigoPostal: string | null,
        public CategoriaSuterhId: number | null,
        public ClaveSuterh: string | null,
        public Observaciones: string | null,
        public Activo: boolean | null
    ) {}
}

export class SearchComunidadItemDto{
    constructor(
        public Id: number,
        public Nombre: string | null,
        public FotoPerfilUrl: string | null,
        public TipoNombre: string | null,
        public Activo: boolean,
        public ConsorcioId: number,
        public Consorcio: string | null,
        public Direccion: string | null,
    ){}
}

export class SearchComunidadResponse {
    constructor(
        public readonly count: number,
        public readonly result: Comunidad[]
    ) {}
}

export class UploadComunidadAttachResponseDto {
    constructor (
        public readonly Archivos: ComunidadAdjunto[]
    ) {}
}

export class ComunidadAdjunto {
    constructor (
        public readonly Id: number,
        public Descripcion: string | null,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly ComunidadId: number
    ) {}
}

export class ComunidadSeguros{
    constructor (
        public readonly Id: number,
        public readonly ComunidadId: number,
        public Descripcion: string | null,
        public readonly AdjuntoUrl: string | null,
        public readonly NombreAdjunto: string | null,
        public VigenciaDesde: Date,
        public VigenciaHasta: Date,
        public Activo: boolean,
    ){}
}

export class UploadComunidadSegurosAttachResponseDto {
    constructor (
        public readonly Archivos: ComunidadSeguros[]
    ) {}
}

export class ComunidadNumeroEmergencia {
    constructor (
        public readonly Id: number,
        public readonly Descripcion: string | null,
        public readonly NumeroContacto: string | null,
        public readonly ComunidadId: number
    ) {}
}

export class ComunidadTiposGastos {
    constructor (
        public readonly Id: number,
        public readonly TipoGastoId: number,
        public readonly TipoGasto: string | null,
        public readonly ComunidadId: number,
        public readonly Comunidad: string
    ) {}
}

export class ComunidadTipoGastoConceptoRecargoDto {
    constructor (
        public readonly Id: number,
        public readonly TipoGastoId: number,
        public readonly TipoGasto: string | null,
        public readonly ComunidadId: number
    ) {}
}

export class TipoGastoComunidadServicioGasto {
    constructor (
        public readonly Id: number,
        public readonly TipoGastoComunidadId: number,
        public readonly TipoGastoId: number,
        public readonly TipoGasto: string | null,
        public readonly ServicioGastoId: number,
        public readonly ServicioGastoNombre: string | null,
        public readonly ComunidadId: number,
        public readonly ComunidadNombre: string | null,
        // public readonly ServicioCategoriaGastoId: number,
        // public readonly ServicioCategoriaGastoNombre: string
    ) {}
}